var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListSidebaricon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M3 4.01953V18.0195C3 19.1241 3.89543 20.0195 5 20.0195H17H19C20.1046 20.0195 21 19.1241 21 18.0195V8.01953H17",
    stroke: "#0077FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M3 4.01953H17V18.0195C17 19.1241 17.8954 20.0195 19 20.0195V20.0195",
    stroke: "#0077FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 57",
    d: "M13 8.01953L7 8.01953",
    stroke: "#0077FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 60",
    d: "M13 12.0195L9 12.0195",
    stroke: "#0077FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListSidebaricon);
export default __webpack_public_path__ + "static/media/listSidebaricon.fc7b84b2947ec8bb5a192cd5d75dbf9b.svg";
export { ForwardRef as ReactComponent };